var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-title",on:{"click":_vm.onLogoClick}},[_c('div',{staticClass:"logo-title-box"},[_c('div',{class:'layout-title'},[_c('div',{staticClass:"title-content first-title"},[_vm._v(_vm._s(_vm.g_Config.TITLE))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }